import React, { useEffect } from 'react';
import Header from '../../../Header';
import Footer from '../../../Footer';
import Banner from '../../Banner';
import { Link, useLocation } from 'react-router-dom';

const KVKKAydinlatma: React.FC = () => {
  const location = useLocation();
  const language = location.pathname.startsWith('/en') ? 'en' : 'tr';
  const lang: 'en' | 'tr' = language;

  const setLanguage = (newLang: 'en' | 'tr') => {
    let newPath = location.pathname;
    if (newLang === 'en' && !newPath.startsWith('/en')) {
      newPath = '/en' + (newPath.startsWith('/tr') ? newPath.slice(3) : newPath);
    } else if (newLang === 'tr' && !newPath.startsWith('/tr')) {
      newPath = '/tr' + (newPath.startsWith('/en') ? newPath.slice(3) : newPath);
    }
    window.location.href = newPath;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumb = (
    <>
      <Link to={`/${lang}`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Ana Sayfa' : 'Home'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Sertifikasyon ve Dökümantasyon' : 'Certification & Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification/documents`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Dökümantasyon' : 'Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <span className="text-white font-bold">{lang === 'tr' ? 'Tedarikçi ve Müşterilerin Sözleşme Süreçlerine Yönelik KVKK Aydınlatma Metni' : 'KVKK Disclosure for Supplier & Customer Contracts'}</span>
    </>
  );

  return (
    <div>
      <Header language={lang} setLanguage={setLanguage} />
      <Banner
        title={lang === 'tr' ? 'Tedarikçi ve Müşterilerin Sözleşme Süreçlerine Yönelik KVKK Aydınlatma Metni' : 'KVKK Disclosure for Supplier & Customer Contracts'}
        description={lang === 'tr' ? 'KVKK kapsamında tedarikçi ve müşteri sözleşmelerine yönelik aydınlatma metni.' : 'KVKK disclosure text for supplier and customer contracts.'}
        breadcrumb={breadcrumb}
      />
      <div className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          {lang === 'tr' ? (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Aydınlatma Metninin Amacı</h3>
                <p className="text-gray-700 leading-relaxed">Bu aydınlatma metni, CG Yapay Zeka Teknoloji Yatırımları A.Ş. (CG Teknoloji) ile tedarikçi veya müşteri sıfatıyla sözleşme ilişkisine giren gerçek kişilerin kişisel verilerinin işlenmesine ilişkin 6698 sayılı KVKK'nın 10. maddesi kapsamında hazırlanmıştır.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">İşlenen Kişisel Veriler</h3>
                <p className="text-gray-700 leading-relaxed mb-2">Sözleşme kurulması ve ifası süreçleri kapsamında aşağıdaki kişisel veriler işlenebilir:</p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li>Ad, soyad ve T.C. kimlik numarası</li>
                  <li>İletişim bilgileri (telefon, e-posta, adres)</li>
                  <li>İmza ve yetkili bilgileri</li>
                  <li>Banka ve ödeme bilgileri</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">İşlenme Amaçları</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li>Sözleşmenin kurulması, yürütülmesi ve sona erdirilmesi</li>
                  <li>Muhasebe ve finans süreçlerinin yönetimi</li>
                  <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                  <li>Ticari ilişkinin sürdürülmesi ve geliştirilmesi</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Verilerin Aktarımı</h3>
                <p className="text-gray-700 leading-relaxed">Kişisel verileriniz; yasal zorunluluk halinde yetkili kamu kurum ve kuruluşlarına, mali müşavir ve bağımsız denetçiler gibi hizmet sağlayıcılara yalnızca gerekli ölçüde aktarılabilir.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Saklama Süresi</h3>
                <p className="text-gray-700 leading-relaxed">Verileriniz, sözleşme ilişkisinin sona ermesinin ardından Türk Ticaret Kanunu ve Vergi Usul Kanunu'nda öngörülen süreler boyunca saklanır; bu süreler dolduğunda imha edilir.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Haklarınız</h3>
                <p className="text-gray-700 leading-relaxed">KVKK'nın 11. maddesi kapsamındaki haklarınızı kullanmak için <strong>info@cgteknoloji.com</strong> adresine "KVKK Başvurusu" konusuyla e-posta gönderebilirsiniz.</p>
              </section>
            </div>
          ) : (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Purpose of This Disclosure</h3>
                <p className="text-gray-700 leading-relaxed">This disclosure text has been prepared under Article 10 of the Personal Data Protection Law No. 6698 (KVKK) regarding the processing of personal data of natural persons entering into contractual relationships with CG Yapay Zeka Teknoloji Yatırımları A.Ş. (CG Teknoloji) as suppliers or customers.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Personal Data Processed</h3>
                <p className="text-gray-700 leading-relaxed mb-2">The following personal data may be processed within the scope of contract formation and performance:</p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li>Name, surname, and Turkish ID number</li>
                  <li>Contact information (phone, email, address)</li>
                  <li>Signature and authorized representative information</li>
                  <li>Banking and payment information</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Purposes of Processing</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li>Formation, execution, and termination of contracts</li>
                  <li>Management of accounting and financial processes</li>
                  <li>Fulfillment of legal obligations</li>
                  <li>Maintaining and developing commercial relationships</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Data Transfer</h3>
                <p className="text-gray-700 leading-relaxed">Your personal data may be transferred to authorized public institutions when legally required, and to service providers such as financial advisors and independent auditors only to the extent necessary.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Retention Period</h3>
                <p className="text-gray-700 leading-relaxed">Your data will be retained following the termination of the contractual relationship for the periods stipulated under the Turkish Commercial Code and the Tax Procedure Law, after which it will be destroyed.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Your Rights</h3>
                <p className="text-gray-700 leading-relaxed">To exercise your rights under Article 11 of KVKK, you may send an email to <strong>info@cgteknoloji.com</strong> with the subject "KVKK Application."</p>
              </section>
            </div>
          )}
        </div>
      </div>
      <Footer language={lang} />
    </div>
  );
};

export default KVKKAydinlatma; 